import React, { useEffect, useState } from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import ReactDatePicker from 'react-datepicker';
import currenciesData from 'data/currencies';
import { OptionType } from 'components/common/types';

type AccountsFiltersPropsTypes = {
  values: {
    from: string;
    to: string;
    search: string;
    currencies: string;
  };
  handleSubmit: () => void;
  setFieldValue: (field: string, value: any) => void;
  loading: boolean;
};

const AccountsFilters = (props: AccountsFiltersPropsTypes) => {
  const {
    values: { from = '', to = '', search = '', currencies: currenciesValue = '' } = {},
    handleSubmit,
    setFieldValue,
    loading
  } = props;

  const [currencies, setCurrencies] = useState<OptionType[]>([]);

  useEffect(() => {
    (async () => {
      const data = await currenciesData;
      if (data?.length) setCurrencies(data);
    })();
  }, []);

  return (
    <div className="row g-2 align-items-end mb-3">
      <div className="col-12 col-md-4">
        <Form.Label className="small fw-semibold mb-1">Поиск</Form.Label>
        <Form.Control
          size="sm"
          name="search"
          type="search"
          value={search}
          onChange={e => setFieldValue('search', e.target.value)}
          placeholder="Счёт / телефон / фамилия"
          disabled={loading}
        />
      </div>
      <div className="col-12 col-md-2">
        <Form.Label className="small fw-semibold mb-1">Валюта</Form.Label>
        <Select
          closeMenuOnSelect={false}
          options={currencies as any}
          placeholder="Все"
          isMulti
          isDisabled={loading}
          styles={{
            control: base => ({ ...base, minHeight: '31px', fontSize: '0.875rem' }),
            valueContainer: base => ({ ...base, padding: '0 6px' }),
            dropdownIndicator: base => ({ ...base, padding: '4px' }),
          }}
          classNamePrefix="react-select"
          value={currenciesValue}
          onChange={value => setFieldValue('currencies', value)}
        />
      </div>
      <div className="col-6 col-md-2">
        <Form.Label className="small fw-semibold mb-1">Дата с</Form.Label>
        <ReactDatePicker
          popperPlacement="bottom-start"
          selected={from as any}
          onChange={date => setFieldValue('from', date)}
          formatWeekDay={day => day.slice(0, 3)}
          className="form-control form-control-sm"
          disabled={loading}
          placeholderText="дд.мм.гггг"
        />
      </div>
      <div className="col-6 col-md-2">
        <Form.Label className="small fw-semibold mb-1">Дата по</Form.Label>
        <ReactDatePicker
          popperPlacement="bottom-start"
          selected={to as any}
          onChange={date => setFieldValue('to', date)}
          formatWeekDay={day => day.slice(0, 3)}
          className="form-control form-control-sm"
          disabled={loading}
          placeholderText="дд.мм.гггг"
        />
      </div>
      <div className="col-12 col-md-auto">
        <Button
          variant="primary"
          size="sm"
          disabled={loading}
          onClick={handleSubmit}
          className="d-flex align-items-center gap-2"
        >
          Поиск
          {loading && (
            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
          )}
        </Button>
      </div>
    </div>
  );
};

export default AccountsFilters;
